import React from 'react';
import { Compass, MapPin, Phone, Mail } from 'lucide-react';
import ProtectedContact, { ENCODED_CONTACTS } from './ProtectedContact';

export default function Footer({ setActiveTab }) {
  return (
    <footer className="bg-slate-100 border-t border-slate-200 text-slate-600 text-sm mt-auto">
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          
          {/* Col 1: Brand */}
          <div className="space-y-4 md:col-span-2">
            <div className="flex items-center gap-3">
              <img 
                src="/assets/MAZU.jpg" 
                alt="American Mazu Foundation Logo" 
                className="w-10 h-10 rounded-full border border-amber-600 object-cover"
              />
              <div>
                <h3 className="text-lg font-bold text-[#8B0000] font-serif">
                  美國媽祖基金會
                </h3>
                <p className="text-xs text-gray-500 font-mono">
                  American Mazu Foundation Inc. (usmazu.org)
                </p>
              </div>
            </div>

            <p className="text-xs text-slate-600 leading-relaxed max-w-md">
              美國媽祖基金會成立於2014年，是以弘揚媽祖文化精神為宗旨的非營利公益組織。致力於傳承媽祖立德、行善、博愛的傳統美德，守護海內外華僑信眾。
            </p>

            <div className="text-xs text-slate-500 font-mono flex items-center gap-1">
              <Compass className="w-3.5 h-3.5 text-[#8B0000]" />
              <span>Flushing, New York, USA</span>
            </div>
          </div>

          {/* Col 2: Quick Links */}
          <div className="space-y-3">
            <h4 className="text-[#8B0000] font-bold font-serif text-base border-b border-slate-200 pb-2">
              快速連結 Quick Links
            </h4>
            <ul className="space-y-2 text-xs">
              <li>
                <button onClick={() => setActiveTab('home')} className="hover:text-[#8B0000] transition-colors">
                  首頁 (Home)
                </button>
              </li>
              <li>
                <button onClick={() => setActiveTab('about')} className="hover:text-[#8B0000] transition-colors">
                  關於我們 (About Us)
                </button>
              </li>
              <li>
                <button onClick={() => setActiveTab('culture')} className="hover:text-[#8B0000] transition-colors">
                  媽祖文化與歷史 (Culture & History)
                </button>
              </li>
              <li>
                <button onClick={() => setActiveTab('story')} className="hover:text-[#8B0000] transition-colors">
                  媽祖故事 (Mazu Story)
                </button>
              </li>
              <li>
                <button onClick={() => setActiveTab('gallery')} className="hover:text-[#8B0000] transition-colors">
                  圖庫相冊 (Gallery)
                </button>
              </li>
              <li>
                <button onClick={() => setActiveTab('contact')} className="hover:text-[#8B0000] transition-colors">
                  聯繫我們 (Contact Us)
                </button>
              </li>
            </ul>
          </div>

          {/* Col 3: Contact */}
          <div className="space-y-3">
            <h4 className="text-[#8B0000] font-bold font-serif text-base border-b border-slate-200 pb-2">
              聯絡方式 Contact
            </h4>
            <div className="space-y-2 text-xs">
              <p className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-[#8B0000] shrink-0 mt-0.5" />
                <ProtectedContact encoded={ENCODED_CONTACTS.ADDRESS_SHORT} />
              </p>
              <p className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-[#8B0000] shrink-0" />
                <ProtectedContact encoded={ENCODED_CONTACTS.PHONE} type="tel" prefix="Tel: " />
              </p>
              <p className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-[#8B0000] shrink-0" />
                <ProtectedContact encoded={ENCODED_CONTACTS.EMAIL} type="mailto" prefix="Email: " />
              </p>
            </div>
          </div>

        </div>

        {/* Bottom copyright */}
        <div className="mt-8 pt-6 border-t border-slate-200 text-center text-xs text-slate-500">
          <p>© {new Date().getFullYear()} American Mazu Foundation Inc. (usmazu.org). All rights reserved.</p>
        </div>
      </div>

    </footer>
  );
}
